import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { SenderRegistrationSubmitOTP as VERIFY_OTP } from 'Components/Api/EpocketDMTApi';
import { SenderRegistrationResendOTP as SENDER_RESEND_OTP } from 'Components/Api/EpocketDMTApi';
import { Select as SENDER_SELECT } from 'Components/Api/EpocketDMTApi';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';

import { Container, Grid, Paper, Button, Hidden } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import { useLocation } from 'react-router-dom';
import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const BeneficiaryVerify = () => {
    const classes = commonStyle();
    const history = useHistory();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const location = useLocation();
    const BeneficiaryID = location.state.BeneficiaryID;
    const Mobile = location.state.Mobile;
    const [formObject, setFormObject] = useState({
        Mobile: '',
        OTP: '',
        SenderID: '',
        BeneficiaryID: '',
        ActionType: '',
        isSecondSubmit: false
    });

    const resendOTP = async (values) => {
        var requestObj = JSON.stringify(values);
        setLoading(true);
        setIsError(false);
        var response = await SENDER_RESEND_OTP(requestObj);
        if (!response.isAuthorized) LOGOUT();

        setLoading(false);
        setIsError(true);
        setSeverity('success');
        setResponseMessage(response.data);
        if (!response.status) {
            setSeverity('error');
            return;
        }
    };

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        if (loading) {
            setLoading(false);
            return;
        }
        var requestObj = JSON.stringify(values);

        setLoading(true);
        setIsError(false);

        if (values.isAddBeneficiary) {
            resendOTP(values);
            return;
        }

        var response = await VERIFY_OTP(requestObj);
        if (!response.isAuthorized) {
            LOGOUT();
        }

        setIsError(true);
        setSeverity('success');
        setResponseMessage(response.data);

        if (!response.status) {
            setLoading(false);
            setSeverity('error');
            return;
        }
        resetForm(formObject);

        var param = {
            Mobile: values.Mobile
        };

        history.push('/EDMT/Sender/Search/', param);
    };

    const select = async () => {
        setLoading(true);

        let primaryID = Mobile;

        setLoading(false);
        if (primaryID === 'DMT') {
            return;
        }

        var requestObj = JSON.stringify({ Mobile: primaryID });
        var response = await SENDER_SELECT(requestObj);

        if (!response.isAuthorized) {
            LOGOUT();
        }

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);

        setFormObject({
            ...formObject,
            Mobile: data.Mobile,
            SenderID: data.SenderID,
            BeneficiaryID: BeneficiaryID,
            ActionType: 'REGISTRATION',
            OTP: ''
        });
    };

    useEffect(() => {
        select();
    }, []);

    const FormValidationSchema = Yup.object({
        Mobile: Yup.string().required(PLEASE_PROVIDE_VALID + 'mobile'),
        OTP: Yup.string().required(PLEASE_PROVIDE_VALID + 'otp')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>
                                Beneficiary Verify
                            </h2>
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={6}
                                            lg={6}
                                        >
                                            <MaterialNumberField
                                                label="Mobile"
                                                name="Mobile"
                                                type="Mobile"
                                                length={10}
                                                readOnly={true}
                                                placeholder="Mobile"
                                            />
                                        </Grid>
                                        <Hidden xsUp>
                                            <MaterialTextField
                                                label="SenderID"
                                                name="SenderID"
                                                type="text"
                                                readOnly={true}
                                                placeholder="SenderID"
                                            />
                                        </Hidden>

                                        <Hidden xsUp>
                                            <MaterialTextField
                                                label="BeneficiaryID"
                                                name="BeneficiaryID"
                                                type="text"
                                                readOnly={true}
                                                placeholder="BeneficiaryID"
                                            />
                                        </Hidden>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={6}
                                            lg={6}
                                        >
                                            <MaterialTextField
                                                label="OTP"
                                                name="OTP"
                                                length={6}
                                                type="text"
                                                placeholder="OTP"
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid className={classes.footerGrid}>
                                <Box className={classes.flexReverse}>
                                    <div className={classes.SubmitWrapper}>
                                        <Button
                                            type="submit"
                                            title="Verify"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            onClick={(e) => {
                                                setFieldValue(
                                                    'isSecondSubmit',
                                                    false
                                                );
                                                handleSubmit(e);
                                            }}
                                            disabled={loading}
                                        >
                                            Verify
                                        </Button>
                                        {loading && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>

                                    <div
                                        className={
                                            classes.SubmitWrapperWithMarginRight
                                        }
                                    >
                                        {loading && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>
                                    <Button
                                        type="reset"
                                        title="Reset"
                                        className={
                                            classes.CustomDangerButtonStyle
                                        }
                                    >
                                        Reset
                                    </Button>
                                </Box>
                            </Grid>
                        </Form>
                    );
                }}
            />
        </CustomContainer>
    );
};
